import React, { useState } from 'react';

const experiences = [
    {
        date: 'August 2024 - Present',
        title: 'Co-Founder and CTO',
        company: 'DevelopIQ',
        description: 'Built and deployed the full-stack web platform for a startup, using React, Python, and JavaScript.',
        tags: ['Python', 'JavaScript', 'CSS', 'React'],
        link: 'https://developiq.org/',
    },
    {
        date: 'May 2025 - Present',
        title: 'Software Engineer Intern',
        company: 'USAA',
        description: 'Ready for new opportunities and challenges.',
        tags: ['Javascript', 'React', 'Java', 'SprintBoot'],
        link: 'https://www.usaa.com/?akredirect=true',
    },
    {
        date: 'Jan 2023 - May 2025',
        title: 'Coding Instructor',
        company: 'Vandergriff Elementary',
        description: 'Taught 2nd - 4th grade students the basics of programming.',
        tags: ['Collaboration', 'Problem Solving'],
        link: 'https://vandergriff.fayar.net/',
    },
    {
        date: 'May 2024 - July 2024',
        title: 'Software Engineer Intern',
        company: 'Trashy Studios',
        description: 'Worked on filters and UI for an iOS photo editing application.',
        tags: ['Swift', 'SwiftUI', 'MetalPetal'],
        link: 'https://apps.apple.com/ca/app/gloss-studio/id6448875676',
    },
];

const ExperienceCard = ({ date, title, company, description, tags, link }) => {
    const [isHovered, setIsHovered] = useState(false);

    const scale = isHovered ? 1.05 : 1;

    return (
        <a
            href={link}
            target="_blank"
            rel="noopener noreferrer"
            style={{
                textDecoration: 'none',
                display: 'block',
            }}
        >
            <div
                style={{
                    background: '#1C1C1E',
                    borderRadius: '12px',
                    padding: '1.5rem',
                    width: '350px',
                    height: '200px',
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '0.5rem',
                    cursor: 'pointer',
                    transform: `scale(${scale})`,
                    transition: 'transform 0.2s ease-in-out',
                }}
                onMouseEnter={() => setIsHovered(true)}
                onMouseLeave={() => setIsHovered(false)}
            >
                <span style={{ color: '#8E8E93', fontSize: '0.9rem' }}>{date}</span>
                <h3 style={{ color: '#fff', fontSize: '1.25rem', fontWeight: 'bold', margin: 0 }}>{title}</h3>
                <span style={{ color: '#E5E5EA', fontSize: '1rem' }}>{company}</span>
                <p style={{ color: '#E5E5EA', fontSize: '1rem', margin: '0.5rem 0 1rem 0' }}>{description}</p>
                <div style={{ display: 'flex', flexWrap: 'wrap', gap: '0.5rem', marginTop: 'auto' }}>
                    {tags.map((tag, index) => (
                        <span key={index} style={{
                            background: '#3A3A3C',
                            borderRadius: '8px',
                            padding: '0.3rem 0.75rem',
                            fontSize: '0.9rem',
                            color: '#E5E5EA',
                        }}>
                            {tag}
                        </span>
                    ))}
                </div>
            </div>
        </a>
    );
};

const Experience = () => (
    <section id="experience" style={{
        background: '#000',
        color: '#fff',
        padding: '4rem 2rem',
        textAlign: 'center',
    }}>
        <h2 style={{ fontSize: '2.5rem', marginBottom: '3rem', fontWeight: 'bold' }}>Experience</h2>
        <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(2, 1fr)',
            gap: '2rem',
            maxWidth: '800px',
            margin: '0 auto',
        }}>
            {experiences.map((exp, index) => (
                <ExperienceCard key={index} {...exp} />
            ))}
        </div>
    </section>
);

export default Experience; 